import { sentenceCase } from '@iheartjane/utils';

import { lineageOptions } from '@jane/shared-b2b/util';

/** The lineage labels the rest of B2B uses, ex `cbd` reads "CBD" */
const LINEAGE_LABELS = new Map(
  lineageOptions().map((option) => [option.value, option.label])
);

/** Sentence case renders `cbd` as "Cbd", so known lineages take priority */
export const lineageLabel = (lineage: string | undefined): string =>
  lineage ? (LINEAGE_LABELS.get(lineage) ?? sentenceCase(lineage)) : '';
